<template>

  <h1>Garment Types</h1>

  <div class="content-section">
    <div class="action-bar">
      <a href="/garmenttypes/create">
        <button type="button" class="btn btn-primary">Create new</button>
      </a>
    </div>

    <div v-if="isListing">
      <span>Find garment type: </span>
      <input type="text" v-model="searchValue">

      <easy-data-table
          :headers="headers"
          :items="garmenttypes"
          :search-field="searchField"
          :search-value="searchValue"
          alternating
          border-cell
          buttons-pagination
      >
        <template #item-operations="item">
          <div class="operation-wrapper">
            <router-link
                :to="{
                name: 'GarmentTypeEdit',
                params: {
                  id: item.garmenttypeid
                }
              }">


              <font-awesome-icon
                  icon="edit"
                  size="1x"
                  class="operation-icon"
                  title="Edit"
              >
              </font-awesome-icon>
            </router-link>
          </div>
        </template>

      </easy-data-table>
    </div>
  </div>
</template>

<script setup>
  import {ref, onMounted} from "vue";
  import GarmentTypeService from "@/services/GarmentTypeService";

  const garmenttypes =  ref([]);
  const searchField = ref("garmenttype");
  const searchValue = ref("");
  const headers = [
    { text: "ID", value: "garmenttypeid", sortable: true  },
    { text: "Garment Type", value: "garmenttype", sortable: true  },
    { text: "Priority", value: "prioritygt", sortable: true  },
    { text: "Is active?", value: "active", sortable: true  },
    { text: "Is Master type?", value: "is_maintype", sortable: true  },
    { text: "Actions", value: "operations" },
  ];

  const isListing = ref(true);
  const isEditing = ref(false);

  function getGarmentTypes() {
      GarmentTypeService.getAll()
          .then(response => {
            garmenttypes.value = response.data.data.garment_types;
          })
          .catch(e => {
            console.log(e);
          });
  }

  function editGarmentType(item) {
    router.push('/garmenttype/' + item.garmenttypeid);
  }
  onMounted(() => {
    getGarmentTypes();
  })

</script>
